import Vue from 'vue';
import i18n from "../../../i18n";

export default {

  async createUser({ commit }, payload) {
    return Vue.axios
      .post(Vue.$url("user"), payload)
      .then((rsp) => {
        Vue.$log.debug("user created and saved under", rsp.data.ID);
        commit('mShowInfoMessage', i18n.t('common.saved', { 0: 'User', 1: payload.username }), {root: true});
        return rsp.data;
      })
  },

  async createUserProjectVesselMapping({ commit }, payload) {
    return Vue.axios
      .post(Vue.$url('user/' + payload.uId + '/project-vessel/' + payload.pvmId + '/mapping'))
      .then((rsp) => {
        commit('SET_NOOP');
        return rsp.data;
      })
  },

  async deleteUserProjectVesselMapping({ commit }, payload) {
    return Vue.axios
      .delete(Vue.$url('user/' + payload.uId + '/project-vessel/'  + payload.pvmId + '/mapping'))
      .then((rsp) => {
        commit('SET_NOOP');
        return rsp.data;
      })
  },

  async fetchUsers({ commit }) {
    return Vue.axios.get(Vue.$url("user"))
      .then((rsp) => commit("SET_USERS", rsp.data))
  },

  async getUserById({ commit }, cuId) {
    return Vue.axios.get(Vue.$url("user/"+ cuId))
      .then((rsp) => commit("SET_USER", rsp.data))
  },

  async fetchUserProjects({ commit }, cuId) {
    return Vue.axios.get(Vue.$url("user/"+ cuId + "/projects"))
      .then((rsp) => commit("SET_USER_PROJECTS", rsp.data))
  },

  async deleteUser({  commit }, payload) {
    Vue.$log.debug('trying to delete User', payload.id);
    return Vue.axios
      .delete(Vue.$url("user/" + payload.id))
      .then(() => commit('mShowInfoMessage', i18n.t('common.lockupdate', { 0: payload.username }), {root: true}));
  },

  async updateUser({ commit }, payload) {
    return Vue.axios
      .put(Vue.$url("user/" + payload.id), payload)
      .then((rsp) => {
        commit('mShowInfoMessage', i18n.t('common.updated', { 0: 'User', 1: payload.username }), {root: true});
        return rsp.data;
      });
  },
}